<template>
  <div class="card">
    <div class="card-header bg-transparent tabtn">
      <div class="row align-items-center">
        <div class="col red">
          <h3>
            <i class="fas fa-flag"></i> State Report
          </h3>
        </div>
        <button
          type="button"
          v-bind:class="{ 'btn-primary': isGeoMapView }"
          class="btn btn-sm"
          @click="isGeoMapView = true,setGeoMap()"
        >Map View</button>
        <button
          type="button"
          v-bind:class="{ 'btn-primary': !isGeoMapView }"
          class="btn btn-sm"
          @click="isGeoMapView = false"
        >Chart View</button>
        <div class="text-right">
          <label class="custom-toggle">
            <input
              v-model="stateBuyOrSell"
              type="checkbox"
              @change="setStateReportData"
              id="stateCheck"
            />
            <span class="custom-toggle-slider rounded-circle"></span>
          </label>
        </div>
      </div>
    </div>
    <div class="card-body">
      <!-- Chart -->
      <div v-show="isGeoMapView" class="chart geomap">
        <div id="regions_div"></div>
      </div>
      <div v-show="!isGeoMapView" class="chart geomap">
        <canvas id="stateChart"></canvas>
      </div>
      <a href class="text-right view-more" @click="showPopup">
        View More
        <i class="fa fa-arrow-circle-right"></i>
      </a>
    </div>
    <!-- Modal -->
    <div
      class="modal fade bd-example-modal-xl"
      id="chartViewMoreState"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">State Report</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="subHead">
              <div class="mt-4 mr-4">
                <button
                  type="button"
                  v-bind:class="{ 'btn-primary': isGeoMapViewPopup }"
                  class="btn btn-sm"
                  @click="isGeoMapViewPopup = true,setGeoMapPoup()"
                >Map View</button>
                <button
                  type="button"
                  v-bind:class="{ 'btn-primary': !isGeoMapViewPopup }"
                  class="btn btn-sm"
                  @click="isGeoMapViewPopup = false"
                >Chart View</button>
              </div>
              <div class="text-right">
                <span class="lbl">Buy</span>
                <label class="custom-toggle">
                  <input
                    type="checkbox"
                    v-model="popupStateBuyOrSell"
                    @change="setPopupStateReportData"
                  />
                  <span class="custom-toggle-slider rounded-circle"></span>
                </label>
                <span class="lbl">Sell</span>
              </div>
            </div>
            <div class="graph">
              <div v-show="isGeoMapViewPopup" id="regions_div_popup"></div>
              <div v-show="!isGeoMapViewPopup">
                <canvas id="stateChartPoup"></canvas>
              </div>
              <!-- <canvas id="canvasPopup"></canvas> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */

//import ChoroplethChart from "./ChoroplethChart.vue";
//import { topojson } from "chartjs-chart-geo";
//import this.$http from "this.$http";
import config from "@/config";
//import $ from "jquery";
import chartConstants from "@/chartConstants";
//import Chart from "chart.js";
// import "chartjs-chart-geo";
import { GoogleCharts } from "google-charts";
import stateConstants from "@/stateConstants";

//import 'chartjs-plugin-datalabels';
export default {
  components: {
    //ChoroplethChart
  },
  props: ["fromdate", "todate"],
  watch: {
    $props: {
      handler: function() {
        this.getStateReportData();
      },
      deep: true
    }
  },
  data() {
    return {
      accessToken: null,
      stateBuyOrSell: false,
      stateChartOptions: chartConstants.stateBarChartDefault,
      stateChartData: {},
      popupStateChartOptions: chartConstants.stateBarChartDefaultPopup,
      popupStateChartData: {},
      popupStateBuyOrSell: false,
      nation: [],
      state: [],
      myChart: null,
      myChartPopup: null,
      stateConstants: stateConstants,
      isGeoMapView: true,
      isGeoMapViewPopup: true
    };
  },
  methods: {
    getStateReportData() {
      const auth = { headers: { authorization: this.accessToken } };
      this.$http
        .get(
          config.baseUrl +
            "/report/state?fromDate=" +
            this.fromdate +
            "&toDate=" +
            this.todate +
            "&dashboard=True",
          auth
        )
        .then(result => {
          this.stateChartData = result.data.data;
          this.setStateReportData();
        });
    },
    setGeoMap() {
      setTimeout(() => this.setStateReportData(), 500);
    },
    setGeoMapPoup() {
      setTimeout(() => this.setPopupStateReportData(), 500);
    },
    setStateReportData() {
      var stateArray = [];
      var stateBarChartLabels = [];
      var stateBarChartData = [];
      stateArray = [["State", "Select"]];
      for (let i = 0; i < this.stateConstants.length; i++) {
        var dataSet = [
          this.stateConstants[i].name,
          this.getCusipCountPerState(this.stateConstants[i].name)
        ];
        stateArray.push(dataSet);
        stateBarChartLabels.push(this.stateConstants[i].name);
        stateBarChartData.push(
          this.getCusipCountPerState(this.stateConstants[i].name)
        );
      }
      var data = GoogleCharts.api.visualization.arrayToDataTable(stateArray);
      var options = {
        region: "US",
        displayMode: "regions",
        resolution: "provinces",
        colorAxis: { colors: ["#FF0000", "#FFA500", "#008000"] }
      };
      if (this.isGeoMapView) {
        var chart = new GoogleCharts.api.visualization.GeoChart(
          document.getElementById("regions_div")
        );
        chart.draw(data, options);
      }

      //Draw StateChart
      this.stateChartOptions.data.labels = stateBarChartLabels;
      this.stateChartOptions.data.datasets[0].data = stateBarChartData;

      if (this.myChart) {
        this.myChart.destroy();
      }

      const ctx = document.getElementById("stateChart");
      this.myChart = new window.Chart(ctx, {
        type: this.stateChartOptions.type,
        data: this.stateChartOptions.data,
        options: this.stateChartOptions.options
      });
    },
    getCusipCountPerState(state) {
      let stateObj;
      if (this.stateBuyOrSell) {
        stateObj = this.stateChartData.sells.find(
          element => state == Object.keys(element)[0]
        );
      } else {
        stateObj = this.stateChartData.buys.find(
          element => state == Object.keys(element)[0]
        );
      }
      if (stateObj) {
        return stateObj[Object.keys(stateObj)[0]] || 0;
      } else {
        return 0;
      }
    },
    getCusipCountPerStatePopUp(state) {
      let stateObj;
      if (this.popupStateBuyOrSell) {
        stateObj = this.popupStateChartData.sells.find(
          element => state == Object.keys(element)[0]
        );
      } else {
        stateObj = this.popupStateChartData.buys.find(
          element => state == Object.keys(element)[0]
        );
      }
      if (stateObj) {
        return stateObj[Object.keys(stateObj)[0]] || 0;
      } else {
        return 0;
      }
    },
    getPopupStateReportData() {
      const auth = { headers: { authorization: this.accessToken } };
      this.$http
        .get(
          config.baseUrl +
            "/report/state?fromDate=" +
            this.fromdate +
            "&toDate=" +
            this.todate +
            "&dashboard=false",
          auth
        )
        .then(result => {
          this.popupStateChartData = result.data.data;
          this.setPopupStateReportData();
        });
    },
    setPopupStateReportData() {
      var stateArray = [];
      var stateBarChartLabels = [];
      var stateBarChartData = [];
      stateArray = [["State", "Select"]];
      for (let i = 0; i < this.stateConstants.length; i++) {
        var dataSet = [
          this.stateConstants[i].name,
          this.getCusipCountPerStatePopUp(this.stateConstants[i].name)
        ];
        stateArray.push(dataSet);
        stateBarChartLabels.push(this.stateConstants[i].name);
        stateBarChartData.push(
          this.getCusipCountPerState(this.stateConstants[i].name)
        );
      }
      var data = GoogleCharts.api.visualization.arrayToDataTable(stateArray);
      var options = {
        region: "US",
        displayMode: "regions",
        resolution: "provinces",
        colorAxis: { colors: ["#FF0000", "#FFA500", "#008000"] }
      };
      if (this.isGeoMapViewPopup) {
        var chart = new GoogleCharts.api.visualization.GeoChart(
          document.getElementById("regions_div_popup")
        );
        chart.draw(data, options);
      }
      //Draw StateChart
      this.popupStateChartOptions.data.labels = stateBarChartLabels;
      this.popupStateChartOptions.data.datasets[0].data = stateBarChartData;

      if (this.myChartPopup) {
        this.myChartPopup.destroy();
      }

      const ctx = document.getElementById("stateChartPoup");
      this.myChartPopup = new window.Chart(ctx, {
        type: this.popupStateChartOptions.type,
        data: this.popupStateChartOptions.data,
        options: this.popupStateChartOptions.options
      });
    },
    showPopup(event) {
      event.preventDefault();
      GoogleCharts.load(this.getPopupStateReportData, {
        packages: ["geochart"],
        mapsApiKey: config.googleChartApiKey
      });
      window.$("#chartViewMoreState").modal("show");
    }
  },
  mounted() {
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.accessToken = result;
        GoogleCharts.load(this.getStateReportData, {
          packages: ["geochart"],
          mapsApiKey: config.googleChartApiKey
        });
      }
    });
  }
};
</script>
